<template>
    <div class="modal fade" id="modal-enc-processo">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Encerrar processo</h4>
                    <button type="button" class="close" @click="close_modal">&times;</button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label>Conclusão</label>
                                <textarea class="form-control form-control-sm" v-model="conclusao" cols="30" rows="12"></textarea>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <div class="row">
                        <div class="col-auto">
                            <button type="submit" class="btn btn-sm btn-light mr-2" id="enc-submit" @click="save">Salvar</button>
                            <button class="btn btn-sm btn-light" @click="close_modal">Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/mixins/api.js'

    export default {
        name: "encerramento-modal",
        props: [ 'denuncia', 'block' ],
        mixins: [ api ],

        data() { 
            return {
                conclusao: ""
            }
        },

        methods: {
            save() {
                const question = confirm("Isto encerrará o processo e não permitirar futuras alterações.");
                if ( question ){
                    this.submit();
                }
            },

            async submit() {
                const conclusao = {
                    usuario_id: this.$store.state.user.id,
                    conclusao: this.conclusao
                }

                const response = await this.POST(`Denuncia/Conclusao/${this.denuncia.id}`, conclusao);

                if ( response.status === 'success') {
                    this.$emit("alert", { status: "success", result: "Denúncia encerrada com sucesso."} );
                    $("#modal-enc-processo").modal('hide');
                }
            },

            close_modal() {
                $("#modal-enc-processo").modal('hide');
                setTimeout(() => $("#modal-denuncia").modal('show'), 400 );
            }
        },
    }
</script>